import { apiSalesWeb } from '@shared/config';
import { CardBrandEnum } from '@shared/types';

export interface ICreateRequestPaymentInput {
  cardNumber: string;
  brand: CardBrandEnum;
  confirmationNumber: string;
  expirationDate: string;
  holderName: string;
  holderDocument: string;
  customerAddress: {
    postalCode: string;
    complement?: string;
    number: string;
    street: string;
    district: string;
    city: string;
    state: string;
  };
}

export interface ICreateRequestPaymentOutput {
  id: string;
}

export function createRequestPaymentInput({
  ...payload
}: ICreateRequestPaymentInput) {
  return apiSalesWeb.post<ICreateRequestPaymentOutput>(
    '/request-payment',
    payload,
  );
}
